var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "e-filters",
        {
          ref: "filters",
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
          scopedSlots: _vm._u([
            {
              key: "after_buttons",
              fn: function () {
                return [
                  _c("e-button", {
                    staticClass: "ml-1 btn-sm-block",
                    attrs: {
                      id: "sale-download",
                      variant: "primary",
                      icon: "download",
                      busy: _vm.downloading,
                      text: _vm.$t("Baixar"),
                    },
                    on: { click: _vm.downloadReport },
                  }),
                  _c("a", {
                    ref: "downloadLink",
                    staticStyle: { display: "none" },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "order-id",
                          name: "orderId",
                          label: _vm.$t("Id da venda"),
                          type: "text",
                        },
                        model: {
                          value: _vm.filters.saleId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "saleId", $$v)
                          },
                          expression: "filters.saleId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("e-store-combo", {
                        attrs: {
                          id: "order-store_id",
                          required: false,
                          "only-active-options": true,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.storeChanged()
                          },
                        },
                        model: {
                          value: _vm.filters.storeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "storeId", $$v)
                          },
                          expression: "filters.storeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "sale-paybox_id",
                          type: "vue-select",
                          label: _vm.$t("Caixa"),
                          placeholder: _vm.$t("Selecione"),
                          options: _vm.payBoxesOptions,
                        },
                        model: {
                          value: _vm.filters.payBoxId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "payBoxId", $$v)
                          },
                          expression: "filters.payBoxId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "sale-invoice_number",
                          type: "number",
                          label: _vm.$t("Número da NF"),
                        },
                        model: {
                          value: _vm.filters.invoiceNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "invoiceNumber", $$v)
                          },
                          expression: "filters.invoiceNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("e-search-sku", {
                        attrs: {
                          id: "order-sku_id",
                          required: false,
                          "include-fixed-assets": true,
                        },
                        model: {
                          value: _vm.filters.skuId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "skuId", $$v)
                          },
                          expression: "filters.skuId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "order-price_table",
                          type: "vue-select",
                          label: _vm.$t("Tabela de preço"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.getComboPriceTables,
                        },
                        model: {
                          value: _vm.filters.priceTableId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "priceTableId", $$v)
                          },
                          expression: "filters.priceTableId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "order-status",
                          name: "delivery",
                          label: _vm.$t("Origem"),
                          placeholder: _vm.$t("Todos"),
                          type: "vue-select",
                          options: _vm.saleOriginToOrderOptions(),
                        },
                        model: {
                          value: _vm.filters.origin,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "origin", $$v)
                          },
                          expression: "filters.origin",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "order-status",
                          name: "delivery",
                          multiple: "",
                          label: _vm.$t("Status Pedido"),
                          placeholder: _vm.$t("Todos"),
                          type: "vue-select",
                          options: _vm.localSaleStatusOptions,
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("e-person-search", {
                        attrs: {
                          id: "order-customer_id",
                          label: _vm.$t("Cliente"),
                          "is-customer": "",
                          "only-active": false,
                        },
                        model: {
                          value: _vm.filters.customerId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "customerId", $$v)
                          },
                          expression: "filters.customerId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "order-period_type",
                          type: "vue-select",
                          label: _vm.$t("Tipo do período"),
                          options: _vm.orderDates(),
                          clearable: false,
                        },
                        model: {
                          value: _vm.filters.periodType,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "periodType", $$v)
                          },
                          expression: "filters.periodType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "period",
                          type: "date-range-picker",
                          label: _vm.$t("Período"),
                        },
                        model: {
                          value: _vm.filters.rangeDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "rangeDate", $$v)
                          },
                          expression: "filters.rangeDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "sale-echope_classification",
                          type: "vue-select",
                          label: _vm.$t("Classificação echope"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.echopeClassificationOptions(),
                        },
                        model: {
                          value: _vm.filters.echopeClassification,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "echopeClassification", $$v)
                          },
                          expression: "filters.echopeClassification",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "sale-is_installment",
                          type: "vue-select",
                          label: _vm.$t("Venda parcelada"),
                          placeholder: _vm.$t("Todas"),
                          options: _vm.yesNoTypes(),
                        },
                        model: {
                          value: _vm.filters.isInstallment,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "isInstallment", $$v)
                          },
                          expression: "filters.isInstallment",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.getData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "bordered",
            attrs: {
              id: "order-table",
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("SALE.NAME"),
                "female",
                _vm.queryExecuted
              ),
              fields: _vm.fields,
              items: _vm.sales,
              "tbody-tr-class": _vm.rowClass,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(delivery)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.delivery, type: "yesNo" },
                    }),
                  ]
                },
              },
              {
                key: "cell(consigned)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.consigned, type: "yesNo" },
                    }),
                  ]
                },
              },
              {
                key: "custom-foot",
                fn: function () {
                  return [
                    _c("tr", [
                      _c(
                        "th",
                        { staticClass: "text-right", attrs: { colspan: "9" } },
                        [_vm._v(" Total ")]
                      ),
                      _c("th", { staticClass: "text-center" }, [
                        _vm._v(
                          " " + _vm._s(_vm._f("currency")(_vm.netValue)) + " "
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "is-active": row.item.active,
                        "show-update": false,
                        "show-delete": false,
                        "show-activate": false,
                        "show-deactivate": false,
                        buttons: _vm.buttons(row.item),
                      },
                      on: {
                        "cancel-order": function ($event) {
                          return _vm.cancelOrder(row)
                        },
                        "order-read-only": function ($event) {
                          return _vm.showOrderReadOnly(row)
                        },
                        update: function ($event) {
                          return _vm.showOrderUpdate(row)
                        },
                        "print-order": function ($event) {
                          return _vm.onPrint(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            { staticClass: "pt-1" },
            [
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-color-subtitled", {
                    attrs: {
                      colors: [
                        {
                          backgroundColor: "table-danger",
                          title: _vm.$t("Cancelado"),
                        },
                      ],
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "order-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("e-modal-order-cancelation", {
        ref: "modalCancelation",
        on: { "after-confirm": _vm.getData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }